import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { AttendanceConfirm } from "@/features/booking/modules/attendance-confirm/attendance-confirm";
import { m } from "@/paraglide/messages.js";

/**
 * Where the "I'll be there" / "I can't make it" links in a reminder email land. Public, because
 * the person tapping it is usually on their phone's mail app and not signed in anywhere.
 */
export const Route = createFileRoute("/(public)/booking/confirm/")({
  staticData: { sitemap: false },
  component: RouteComponent,
  loader: () => ({ crumb: m.booking_confirm_crumb() }),
  validateSearch: z.object({
    token: z.string().optional(),
    answer: z.enum(["yes", "no"]).optional().catch(undefined),
  }),
});

function RouteComponent() {
  const { token, answer } = Route.useSearch();
  return (
    <main className="flex min-h-svh items-center justify-center bg-background px-4 py-10">
      <AttendanceConfirm token={token} answer={answer} />
    </main>
  );
}
